import { useMemo, useState } from 'react'

import { useAccounts } from '../../hooks/use-accounts'
import { useTransactions } from '../../hooks/use-transactions'
import { getBegginingOfDay } from '../balance-chart/balance-chart.container'
import { TransactionList, TransactionListProps } from './transaction-list'
import { TransactionListMobile } from './transaction-list-mobile'

export function TransactionListContainer(props: TransactionListProps) {
    const [date, setDate] = useState([undefined, getBegginingOfDay(new Date())])

    const { transactions, updateNextToken, loading, nextAvailable } =
        useTransactions({
            type: props.type,
            filter: props.filter as string[],
            providers: props.providers as string,
            endDate: date[1],
            startDate: date?.[0] ?? undefined,
        })

    const { accounts, loading: accountsLoading } = useAccounts({
        type: undefined,
    })

    const selectedAccount = useMemo(() => {
        if (!accountsLoading && accounts.length && props?.filter?.length) {
            return accounts.find((acc: any) => acc.id === props?.filter?.[0])
        } else {
            return null
        }
    }, [props.filter, accounts, accountsLoading])

    return props.mobile ? (
        <TransactionListMobile
            transactions={transactions}
            loading={loading}
            nextPage={updateNextToken}
            hideNext={!nextAvailable}
            date={date}
            setDate={setDate}
            selectedAccount={selectedAccount}
            {...props}
        />
    ) : (
        <TransactionList
            transactions={transactions}
            loading={loading}
            nextPage={updateNextToken}
            hideNext={!nextAvailable}
            date={date}
            setDate={setDate}
            selectedAccount={selectedAccount}
            {...props}
        />
    )
}
